'use client';

import React, { ReactNode } from 'react';
import Image, { StaticImageData } from 'next/image';
import { cn } from '@utils';

interface ImageProps {
	source: StaticImageData;
	alt: string;
	type: 'hero' | 'background';
	className?: string;
}

interface BannerProps {
	image?: ImageProps;
	children: ReactNode;
	className?: string;
}

export const Banner = ({ image, children, className }: BannerProps) => {
	const backgroundImageStyle =
		image?.type === 'background'
			? {
					backgroundImage: `url(${image?.source.src})`,
				}
			: undefined;

	const HeroImage = ({ className }: { className?: string }) => {
		if (!image || image.type !== 'hero') return null;

		return (
			<div className={cn('relative h-full w-full', className, image?.className)}>
				<Image src={image.source} alt={image.alt} className="h-full object-cover" fill priority />
			</div>
		);
	};

	return (
		<div
			className={cn(
				'bg-dark-background relative flex',
				image?.type === 'background' && 'bg-cover bg-center bg-no-repeat',
				className,
			)}
			style={backgroundImageStyle}
		>
			<div className={cn('grid-container grid-cols-1 md:grid-cols-2')}>
				{/* TODO: Add breadcrumb menu support */}
				{/* Mobile hero image */}
				<HeroImage className="min-h-36 md:hidden" />
				{/* Content */}
				{children}
				{/* Desktop hero image */}
				<HeroImage className="hidden md:block" />
			</div>
		</div>
	);
};

export const BannerContent = ({
	children,
	className,
}: {
	children: ReactNode;
	className?: string;
}) => {
	return (
		<div
			className={cn(
				'relative ml-auto flex h-full w-full max-w-[calc((var(--width-8xl)-var(--spacing)*8)/2)] flex-col justify-center px-4 py-0 sm:pr-0 md:pl-8 lg:pl-12',
				className,
			)}
		>
			{children}
		</div>
	);
};
